import React from "react";

const VerificationSuccessful = () => {
  return (
    <div className="template-wrapper">
      <h2 className="template-heading">Verification Successful</h2>
      <p className="template-description">
        Activation Successful! Once logged in, please click on the Prescriptions
        tab to view your new prescriptions. You can now login to your account by
        clicking below.
      </p>
      <p
        className="login-btn"
        onClick={() => {
          window.location.href = "/login";
        }}
      >
        Login Now
      </p>
    </div>
  );
};

export default VerificationSuccessful;
